/**
 * Ελληνική διεπαφή (μόνο el)
 */
export const el = {
  appLoading: 'Φόρτωση…',

  loginTitle: 'Καλώς ήρθατε',
  loginSubtitle: 'Συνδεθείτε για πρόσβαση στο λογαριασμό σας',
  email: 'Email',
  password: 'Κωδικός',
  rememberMe: 'Να με θυμάσαι',
  forgotPassword: 'Ξεχάσατε τον κωδικό;',
  forgotPasswordHint: 'Ξεχάσατε τον κωδικό; Επικοινωνήστε με τον διαχειριστή της εταιρείας.',
  forgotPasswordSend: 'Αποστολή email',
  forgotPasswordSending: 'Αποστολή…',
  forgotPasswordSent: 'Έχει σταλεί email επαναφοράς. Ελέγξτε τα εισερχόμενά σας.',
  forgotPasswordError: 'Σφάλμα. Ελέγξτε το email και δοκιμάστε ξανά.',
  forgotPasswordBack: '← Επιστροφή στη σύνδεση',
  signingIn: 'Σύνδεση…',
  signIn: 'Σύνδεση',
  noAccount: 'Δεν έχετε λογαριασμό;',
  signUpLink: 'Εγγραφή',
  loginInvalidCredentials: 'Λάθος email ή κωδικός.',
  loginTooManyRequests: 'Πολλές αποτυχημένες προσπάθειες. Δοκιμάστε αργότερα.',
  loginNetworkError: 'Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας.',
  loginGenericError: 'Η σύνδεση απέτυχε. Δοκιμάστε ξανά.',

  registerTitle: 'Εγγραφή εταιρείας',
  registerSubtitle: 'Δημιουργήστε λογαριασμό για να ξεκινήσετε',
  companyName: 'Όνομα εταιρείας',
  companyNamePlaceholder: 'Όνομα εταιρείας',
  confirmPassword: 'Επανάληψη κωδικού',
  passwordHint: 'Τουλάχιστον 8 χαρακτήρες',
  passwordMin8: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
  passwordsMismatch: 'Οι κωδικοί δεν ταιριάζουν',
  registerCreating: 'Δημιουργία λογαριασμού…',
  registerButton: 'Εγγραφή',
  registerSuccess: 'Η εγγραφή ολοκληρώθηκε! Μεταφορά…',
  registerEmailInUse: 'Αυτό το email είναι ήδη εγγεγραμμένο. Συνδεθείτε.',
  registerInvalidEmail: 'Μη έγκυρο email.',
  registerWeakPassword: 'Αδύναμος κωδικός. Επιλέξτε ισχυρότερο.',
  alreadyHaveAccount: 'Έχετε ήδη λογαριασμό;',
  signInLink: 'Σύνδεση',
  registerTerms: 'Με την εγγραφή αποδέχεστε τους όρους χρήσης και την πολιτική απορρήτου.',

  navInvoices: 'Τιμολόγια',
  navVatMappings: 'Καταχωρήσεις ΑΦΜ',
  navUsers: 'Χρήστες',
  navCompany: 'Εταιρεία',
  navProfile: 'Προφίλ',
  navLogout: 'Αποσύνδεση',
  navEditProfile: 'Επεξεργασία προφίλ',
  navNeedHelp: 'Χρειάζεστε βοήθεια;',
  navMenu: 'Μενού',
  navOpenMenu: 'Άνοιγμα μενού',
  navCloseMenu: 'Κλείσιμο μενού',

  roleOwner: 'Ιδιοκτήτης',
  roleManager: 'Διαχειριστής',
  roleAccountant: 'Λογιστής',
  roleMember: 'Μέλος',

  dashLoading: 'Φόρτωση…',
  dashNoCompanyTitle: 'Χωρίς πρόσβαση σε εταιρεία',
  dashNoCompanyBody: 'Δεν ανήκετε σε καμία εταιρεία. Επικοινωνήστε με τον διαχειριστή.',
  dashStatInvoices: 'Σύνολο τιμολογίων',
  dashStatAmount: 'Συνολικό ποσό',
  dashStatSuppliers: 'Διαφορετικοί προμηθευτές',
  dashUploadTitle: 'Ανέβασμα νέου τιμολογίου',
  dashFromFile: 'Από αρχείο',
  dashFromFileHint: 'PDF, PNG, JPG, JPEG, HEIC, HEIF',
  dashChooseFile: 'Επιλογή αρχείου',
  dashScanTitle: 'Σάρωση εγγράφου',
  dashScanHint: 'Με την κάμερα της συσκευής σας',
  dashOpenCamera: 'Άνοιγμα κάμερας',
  dashProcessing: 'Επεξεργασία τιμολογίου…',
  dashFiltersTitle: 'Φίλτρα & αναζήτηση',
  dashBulkActions: 'Μαζικές ενέργειες',
  dashDownloadSelected: 'Λήψη επιλεγμένων (ZIP + CSV)',
  dashDeleteSelected: 'Διαγραφή επιλεγμένων',
  dashSearchPlaceholder: 'Αναζήτηση: προμηθευτής, ΑΦΜ, αριθμός…',
  dashSearchClear: 'Καθαρισμός αναζήτησης',
  dashSortLabel: 'Ταξινόμηση',
  dashSortNewest: 'Ημερομηνία (νεότερα)',
  dashSortOldest: 'Ημερομηνία (παλαιότερα)',
  dashSortAmountDesc: 'Ποσό (μεγαλύτερο)',
  dashSortAmountAsc: 'Ποσό (μικρότερο)',
  dashSortSupplierAsc: 'Προμηθευτής (Α–Ω)',
  dashSortSupplierDesc: 'Προμηθευτής (Ω–Α)',
  dashSortAriaAsc: 'Αύξουσα ταξινόμηση',
  dashSortAriaDesc: 'Φθίνουσα ταξινόμηση',

  dashFiltersClear: 'Καθαρισμός φίλτρων',
  dashFiltersActive: 'Ενεργά φίλτρα',
  dashFiltersDateRange: 'Εύρος ημερομηνιών',
  dashFiltersPresets: 'Σύνολο',

  dashPresetAll: 'Όλα',
  dashPresetToday: 'Σήμερα',
  dashPreset7d: '7 ημέρες',
  dashPreset30d: '30 ημέρες',
  dashPresetMonth: 'Αυτός ο μήνας',
  dashPresetYear: 'Φέτος',

  dashSelectedCount: (n) => `${n} επιλεγμένα`,
  dashSelectAll: 'Επιλογή όλων',
  dashClearSelection: 'Αποεπιλογή',

  dashNoFilterResults: 'Δεν βρέθηκαν τιμολόγια με αυτά τα φίλτρα',
  dashNoFilterResultsHint: 'Δοκιμάστε διαφορετική αναζήτηση ή καθαρίστε τα φίλτρα.',
  dashOpenInNewWindow: 'Άνοιγμα σε νέο παράθυρο',
  dashRowsPerPage: 'Γραμμές',
  dashTableDate: 'Ημερομηνία',
  dashTableIssuer: 'Εκδότης',
  dashTableVat: 'ΑΦΜ εκδότη',
  dashTableTotal: 'Σύνολο',
  dashTableUploadedBy: 'Ανέβηκε από',
  dashTableUploadedOn: 'Ημερομηνία ανεβάσματος',
  dashTableActions: 'Ενέργειες',
  dashNoInvoices: 'Δεν βρέθηκαν τιμολόγια',
  dashNoInvoicesHint: 'Ανεβάστε το πρώτο σας τιμολόγιο για να ξεκινήσετε.',
  dashDropHint: 'ή σύρετε αρχείο εδώ',
  dashResultCount: (n) => n === 1 ? '1 τιμολόγιο' : `${n} τιμολόγια`,
  dashReviewTitle: 'Έλεγχος στοιχείων τιμολογίου',
  dashPreviewLink: 'Προεπισκόπηση τιμολογίου',
  dashCancel: 'Ακύρωση',
  dashSave: 'Αποθήκευση',

  // AI extraction stepper
  dashScanWithAi: 'Σκανάρισμα με AI',
  dashScanRetry: 'Δοκιμή ξανά',
  dashScanning: 'Σκανάρισμα…',
  dashStepImageAnalysis: 'Ανάλυση εικόνας',
  dashStepDataExtraction: 'Εξαγωγή δεδομένων',
  dashStepWaiting: 'Σε αναμονή',
  dashStepRunning: 'Σε εξέλιξη…',
  dashStepDone: 'Ολοκληρώθηκε',
  dashStepError: 'Σφάλμα',
  dashManualHint: 'Μπορείτε να συμπληρώσετε τα πεδία χειροκίνητα ή πατήστε «Σκανάρισμα με AI».',
  dashAiError: 'Σφάλμα κατά την αυτόματη ανάγνωση. Συμπληρώστε χειροκίνητα.',

  // Bulk upload
  dashBulkUploadTitle: 'Μαζικό ανέβασμα τιμολογίων',
  dashBulkUploadHint: 'Επιλέξτε πολλά PDF / εικόνες ταυτόχρονα',
  dashBulkOpen: 'Μαζικό ανέβασμα',
  dashBulkChooseFiles: 'Επιλογή αρχείων',
  dashBulkAddMore: 'Προσθήκη αρχείων',
  dashBulkScanAll: 'Σκανάρισμα όλων με AI',
  dashBulkSaveAll: 'Αποθήκευση όλων',
  dashBulkRemove: 'Αφαίρεση',
  dashBulkEmpty: 'Δεν έχουν επιλεγεί αρχεία',
  dashBulkProgress: (done, total) => `${done} από ${total}`,
  dashBulkFiles: (n) => n === 1 ? '1 αρχείο' : `${n} αρχεία`,
  dashBulkStatusPending: 'Σε αναμονή',
  dashBulkStatusUploading: 'Ανέβασμα…',
  dashBulkStatusScanning: 'Σκανάρισμα…',
  dashBulkStatusReady: 'Έτοιμο',
  dashBulkStatusSaving: 'Αποθήκευση…',
  dashBulkStatusSaved: 'Αποθηκεύτηκε',
  dashBulkStatusError: 'Σφάλμα',
  dashBulkClose: 'Κλείσιμο',
  dashBulkClearSaved: 'Καθαρισμός αποθηκευμένων',
  dashBulkDuplicate: 'Διπλό αρχείο',
  dashBulkErrorHint: 'Μπορείτε να ανοίξετε τη γραμμή, να διορθώσετε χειροκίνητα τα πεδία και να την αποθηκεύσετε.',
  dashConfirmDeleteTitle: 'Επιβεβαίωση διαγραφής',
  dashDeleteIntro: 'Θέλετε σίγουρα τη διαγραφή του ακόλουθου αρχείου:',
  dashConfirmDeleteNo: 'Όχι',
  dashConfirmDeleteYes: 'Ναι',
  dashDiscardTitle: 'Απόρριψη τρέχοντος τιμολογίου;',
  dashDiscardBody: 'Αν ακυρώσετε τώρα, το τιμολόγιο δεν θα αποθηκευτεί.',
  dashDiscardBack: 'Επιστροφή',
  dashDiscardConfirm: 'Απόρριψη',

  fieldIssueDate: 'Ημερομηνία έκδοσης',
  fieldGrandTotal: 'Συνολικό ποσό',
  fieldIssuerName: 'Επωνυμία εκδότη',
  fieldIssuerVat: 'ΑΦΜ εκδότη',
  fieldInvoiceNumber: 'Αρ. τιμολογίου',
  datePlaceholder: 'ΗΜ/ΜΜ/ΕΕΕΕ',

  dashEditTitle: 'Επεξεργασία τιμολογίου',
  dashLoadMore: 'Φόρτωση περισσότερων',
  dashShowingOf: (shown, total) => `Εμφάνιση ${shown} από ${total}`,

  toastInvoiceUpdated: 'Το τιμολόγιο ενημερώθηκε',
  toastUpdateFailed: 'Αποτυχία ενημέρωσης τιμολογίου',
  toastDuplicateFile: 'Αυτό το αρχείο έχει ήδη ανεβεί.',

  cameraScanTitle: 'Λήψη με κάμερα (ολόκληρη εικόνα)',
  cameraCapture: 'Λήψη σελίδας',
  cameraRemoveLast: 'Αφαίρεση τελευταίας',
  cameraFinish: 'Τέλος',
  cameraPagesCount: 'Σελίδες που καταγράφηκαν',
  cameraNoPages: 'Δεν έχουν καταγραφεί σελίδες ακόμα',
  cameraAddPage: 'Προσθήκη σελίδας',
  cameraTipFullFrame: 'Λήψη ολόκληρου κάδρου — βάλτε το έγγραφο μέσα στην εικόνα και πατήστε το κουμπί',
  cameraTipMultiPage: 'Πολλές λήψεις γίνονται ένα PDF',
  cameraReady: 'Έτοιμη η κάμερα',
  cameraStarting: 'Έναρξη κάμερας…',
  cameraPageRemove: 'Αφαίρεση σελίδας',
  cameraDone: (n) => n === 1 ? 'Ολοκλήρωση (1 σελίδα)' : `Ολοκλήρωση (${n} σελίδες)`,
  cameraPageLabel: (n) => `Σελίδα ${n}`,

  profileTitle: 'Προφίλ',
  profileSubtitle: 'Προσωπικά στοιχεία και ασφάλεια λογαριασμού',
  profilePersonal: 'Προσωπικά στοιχεία',
  profileDisplayName: 'Εμφανιζόμενο όνομα',
  profileNamePlaceholder: 'Το όνομά σας',
  profileSaving: 'Αποθήκευση…',
  profileSaveChanges: 'Αποθήκευση αλλαγών',
  profileSecurity: 'Ασφάλεια',
  profileCurrentPassword: 'Τρέχων κωδικός',
  profileNewPassword: 'Νέος κωδικός',
  profileNewPasswordPlaceholder: 'Τουλάχιστον 8 χαρακτήρες',
  profileConfirmPasswordPlaceholder: 'Επανάληψη νέου κωδικού',
  profileUpdatingPassword: 'Ενημέρωση…',
  profileUpdatePassword: 'Αλλαγή κωδικού',
  profileSignInPrompt: 'Συνδεθείτε για να συνεχίσετε.',
  profileNameRequired: 'Το όνομα είναι υποχρεωτικό',
  profileUpdated: 'Το προφίλ ενημερώθηκε',
  profileUpdateFailed: 'Αποτυχία ενημέρωσης προφίλ',
  profileFillPasswordFields: 'Συμπληρώστε όλα τα πεδία κωδικού',
  profilePasswordShort: 'Ο νέος κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
  profilePasswordMismatch: 'Οι νέοι κωδικοί δεν ταιριάζουν',
  profilePasswordUpdated: 'Ο κωδικός ενημερώθηκε',
  profileWrongPassword: 'Λάθος τρέχων κωδικός',
  profilePasswordChangeFailed: 'Αποτυχία αλλαγής κωδικού',

  // Toasts Dashboard (ίδια keys με μηνύματα)
  toastFailedLoadUser: 'Αποτυχία φόρτωσης δεδομένων χρήστη',
  toastFailedLoadInvoices: 'Αποτυχία φόρτωσης τιμολογίων',
  toastNoUploadPermission: 'Δεν έχετε δικαίωμα ανεβάσματος τιμολογίων',
  toastFileTooLarge: 'Το αρχείο είναι πολύ μεγάλο (μέγ. 15 MB)',
  toastHeicFailed: 'Αποτυχία επεξεργασίας HEIC. Δοκιμάστε άλλη εικόνα.',
  toastPdfFailed: 'Αποτυχία επεξεργασίας PDF',
  toastImageConvertFailed: 'Αποτυχία μετατροπής εικόνας',
  toastAutoExtractFailed: 'Δεν ήταν δυνατή η αυτόματη συμπλήρωση. Συμπληρώστε τα πεδία χειροκίνητα.',
  toastUploadFailed: 'Το ανέβασμα απέτυχε',
  toastNoSavePermission: 'Δεν έχετε δικαίωμα αποθήκευσης',
  toastNoCompany: 'Δεν έχει επιλεγεί εταιρεία',
  toastInvoiceSaved: 'Το τιμολόγιο αποθηκεύτηκε',
  toastSaveFailed: 'Η αποθήκευση απέτυχε',
  toastNoDeletePermission: 'Δεν έχετε δικαίωμα διαγραφής',
  toastNoInvoiceSelected: 'Δεν έχει επιλεγεί τιμολόγιο',
  toastInvoiceDeleted: 'Το τιμολόγιο διαγράφηκε',
  toastDeleteFailed: 'Η διαγραφή απέτυχε',
  toastBulkDeleted: 'Τα επιλεγμένα τιμολόγια διαγράφηκαν',
  toastBulkDeleteFailed: 'Αποτυχία διαγραφής ορισμένων τιμολογίων',
  toastDownloadFailed: 'Η λήψη απέτυχε',

  vatMapLoading: 'Φόρτωση καταχωρήσεων ΑΦΜ…',
  vatMapTitle: 'Καταχωρήσεις ΑΦΜ',
  vatMapSubtitle: 'Συσχετίστε ΑΦΜ προμηθευτών με σταθερή επωνυμία — από αποθηκευμένα τιμολόγια και νέα scans',
  vatMapHint: 'Η λίστα διαβάζει τα ΑΦΜ από τα ήδη αποθηκευμένα τιμολόγια (χωρίς νέο Azure OCR). Όταν διορθώσετε mapping, ενημερώνονται και τα προηγούμενα τιμολόγια με το ίδιο ΑΦΜ.',
  vatMapAddTitle: 'Νέα καταχώρηση',
  vatMapEditTitle: 'Επεξεργασία καταχώρησης',
  vatMapListTitle: 'Καταχωρήσεις',
  vatMapAdd: 'Προσθήκη',
  vatMapUpdate: 'Ενημέρωση',
  vatMapEdit: 'Επεξεργασία',
  vatMapDelete: 'Διαγραφή',
  vatMapCancel: 'Ακύρωση',
  vatMapSaving: 'Αποθήκευση…',
  vatMapSearchPlaceholder: 'Αναζήτηση ΑΦΜ ή επωνυμίας…',
  vatMapNamePlaceholder: 'π.χ. ACME ΑΕ',
  vatMapEmpty: 'Δεν υπάρχουν καταχωρήσεις ακόμα. Προσθέστε το πρώτο ΑΦΜ παραπάνω.',
  vatMapNoResults: 'Δεν βρέθηκαν αποτελέσματα για την αναζήτηση.',
  vatMapAccessDenied: 'Χωρίς πρόσβαση',
  vatMapAccessDeniedBody: 'Μόνο διαχειριστές και ιδιοκτήτες μπορούν να διαχειριστούν καταχωρήσεις ΑΦΜ.',
  vatMapBack: 'Επιστροφή στον πίνακα',
  vatMapAdded: 'Η καταχώρηση προστέθηκε',
  vatMapUpdated: 'Η καταχώρηση ενημερώθηκε',
  vatMapDeleted: 'Η καταχώρηση διαγράφηκε',
  vatMapSaveFailed: 'Αποτυχία αποθήκευσης',
  vatMapDeleteFailed: 'Αποτυχία διαγραφής',
  vatMapLoadFailed: 'Αποτυχία φόρτωσης',
  vatMapNoAccess: 'Δεν έχετε πρόσβαση σε εταιρεία',
  vatMapInvalidVat: 'Το ΑΦΜ πρέπει να είναι 9 ψηφία.',
  vatMapNameRequired: 'Η επωνυμία είναι υποχρεωτική.',
  vatMapDuplicate: 'Υπάρχει ήδη καταχώρηση για αυτό το ΑΦΜ.',
  vatMapConfirmDeleteTitle: 'Διαγραφή καταχώρησης',
  vatMapConfirmDeleteBody: (vat, name) => `Διαγραφή ΑΦΜ ${vat} (${name});`,
  vatMapFromScans: 'Από τιμολόγια',
  vatMapMapped: 'Καταχωρημένο',
  vatMapNeedsReview: 'Χρειάζεται διόρθωση',
  vatMapInvoiceCount: (n) => `${n} τιμολόγι${n === 1 ? 'ο' : 'α'}`,
  vatMapAlternateNames: 'Επωνυμίες στα τιμολόγια',
  vatMapSaveAndSync: 'Αποθήκευση & ενημέρωση τιμολογίων',
  vatMapSynced: (n) => `Ενημερώθηκαν ${n} προηγούμενα τιμολόγια`,
  vatMapNoInvoicesToSync: 'Η καταχώρηση αποθηκεύτηκε (δεν χρειαζόταν αλλαγή σε τιμολόγια)',
  vatMapRegister: 'Καταχώρηση',
  dashNameFromMapping: 'Από καταχώρηση ΑΦΜ',
};

export function formatInvoiceFieldLabel(key) {
  const map = {
    issue_date: el.fieldIssueDate,
    grand_total: el.fieldGrandTotal,
    issuer_company_name: el.fieldIssuerName,
    issuer_vat: el.fieldIssuerVat,
    invoice_number: el.fieldInvoiceNumber,
  };
  return map[key] || key;
}

export function roleLabel(role) {
  const r = String(role || '').toLowerCase();
  if (r === 'owner') return el.roleOwner;
  if (r === 'manager') return el.roleManager;
  if (r === 'accountant') return el.roleAccountant;
  if (r === 'member') return el.roleMember;
  return role || '';
}

export default el;
